var collapsible_list_pair_rtlignore_default = {
  "container": "gsRom",
  "title": "_3YA22",
  "viewerContainer": "_5kytO",
  "titleContainer": "C5KlS",
  "content": "_3tE7r",
  "expandIcon": "_246pA",
  "dndIcon": "e-cvW",
  "RTL": "XpJ1Z",
  "LTR": "JgL4P",
  "itemContainer": "_5HnCM",
  "itemContainerViewer": "yo54y",
  "mouseDown": "kzswz",
  "innerEditor": "QNUxk",
  "item": "U2BDH",
  "floatingAddPluginMenuWrapper": "_9Awv0"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
